var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingScreen"},[_c('transition',{attrs:{"name":"slide"}},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader--text"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }